export default __webpack_public_path__ + "static/media/prestador.52381346.svg";